module.exports = __webpack_public_path__ + "static/img/index_banner.ff9b6056.png";